import React from 'react';
import { useTranslate } from '@refinedev/core';
import { SpinnerWrapper } from '../spinner-wrapper';
import styles from './token-fallback.module.scss';

type TokenFallbackProps = {
    isUserLoading: boolean;
    messageKey?: string;
    containerClassName?: string;
    spinnerOverlayClassName?: string;
    emptyStateClassName?: string;
};

const mergeClasses = (
    base: string,
    override?: string | null | undefined
): string => {
    return [base, override].filter(Boolean).join(' ');
};

export const TokenFallback: React.FC<TokenFallbackProps> = ({
    isUserLoading,
    messageKey = 'token.failed_to_get_token',
    containerClassName,
    spinnerOverlayClassName,
    emptyStateClassName,
}) => {
    const t = useTranslate();

    return (
        <div
            className={mergeClasses(styles.iframeContainer, containerClassName)}
        >
            {isUserLoading ? (
                <div
                    className={mergeClasses(
                        styles.spinnerOverlay,
                        spinnerOverlayClassName
                    )}
                >
                    <SpinnerWrapper size="default" spinning />
                </div>
            ) : (
                <div
                    className={mergeClasses(
                        styles.emptyState,
                        emptyStateClassName
                    )}
                >
                    {t(messageKey)}
                </div>
            )}
        </div>
    );
};
